import api from './api';

export const fetchDeveloperApiCatalog = async () => {
  const response = await api.get('/developer/api-catalog');
  return response.data;
};

export default { fetchDeveloperApiCatalog };
